export default [
    {
      path: '/auth',
      name: 'auth',
      component: () => import('@/views/auth/AuthLogin.vue'),
      meta: {
        layout: 'auth',
        public: true,
      },
    },
  ]
  